// eslint-disable-next-line import/no-anonymous-default-export
export default {
  url: "https://backend-gkopk.vercel.app/",
  //url: "http://localhost:4000/",
};
